import {Fragment, h} from "preact";
import s from "./homeDeliveryPicker.module.css";
import {useHomeDeliveryPicker} from "./useHomeDeliveryPicker";
import { useAppContext } from "../../../../../../contexts";
import {cartArrow, productCartIcon, purpleAlertIcon} from "../../../../../../assets";
import SchedulingTerm from "./SchedulingTerm";

const HomeDeliveryPicker = props => {
    // Destructured component props
    const {
        additionalErrors,
        attendanceId,
        handleSelectedValue,
        handleErrors,
        handleIsFreeFreight,
        handleCartLoader,
        isAddingToCart = false
    } = props;

    // Component logic data
    const componentProps = useHomeDeliveryPicker({
        attendanceId,
        handleSelectedValue,
        handleErrors,
        handleIsFreeFreight,
        handleCartLoader
    });

    // Destructured component logic data
    const {
        formValues,
        zipData,
        errors,
        handleChange,
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Add to cart button variable
    const addToCartButton = !zipData.address ? null : (
        <button
            type={"submit"}
            className={`${s.addToCartButton} ${isAddingToCart ? " opacity-50" : ""} ${highContrast ? "highFormButton" : ""}`}
            disabled={isAddingToCart}
        >
            <p className={`${highContrast ? "highLabelThird" : ""}`}>
                Adicionar ao Carrinho
            </p>
            <img
                src={cartArrow}
                className={`${s.arrowIcon} ${highContrast ? "highImageInvert" : ""}`}
                alt={"Cart icon"}
            />
        </button>
    );

    // Variable for the unavailable address warning
    const unavailableAddress =
        errors.isUnavailable && (
            <p className={`
                text-sabin-red-default text-sm mt-3 leading-none uppercase font-bold
                ${highContrast ? "highLabelSecond" : ""}
            `}>
                NO MOMENTO NÃO ATENDEMOS NO ENDEREÇO INFORMADO
            </p>
        );

    return (
        <Fragment>
            <div className={"w-full flex-col justify-between items-center"}>
                <input
                    type={"text"}
                    name={"zip"}
                    className={`
                        ${s.pickerInput} 
                        ${zipData.address ? ` ${s.isValid}` : ""} 
                        ${errors.isUnavailable || additionalErrors ? ` ${s.isInvalid}` : ""}
                        ${highContrast && zipData.address ? "highBoxShadow" : ""}
                        ${highContrast && (errors.isUnavailable || additionalErrors) ? "highBoxShadow" : ""}
                    `}
                    placeholder={"Digite aqui seu CEP"}
                    value={formValues.zip}
                    onInput={e => handleChange(e)}
                    data-testid="home-delivery-picker-input"
                />


                {!!zipData.address && (
                    <div className={s.resultsContainer}>
                        <div className={"w-full"}>
                            <p className={"text-[18px] font-light text-[#5A5D67]"}>
                                {zipData.address}
                            </p>
                            {/*<input*/}
                            {/*    type="text"*/}
                            {/*    name={"number"}*/}
                            {/*    placeholder={"Informe o número da sua casa"}*/}
                            {/*    className={s.houseNumberInput}*/}
                            {/*    // value={homeDeliveryValues.number}*/}
                            {/*    onInput={e => {}}*/}
                            {/*/>*/}
                        </div>
                        <div className={"w-full flex flex-row items-start justify-between gap-x-6"}>
                            <div className={"font-bold text-[16px]"}>
                                <p className={"text-black"}>
                                    Taxa do serviço móvel
                                </p>
                                <p className={"text-[#27ae60]"}>
                                    CEP: {formValues.zip}
                                </p>
                            </div>
                            <p className={"text-black font-bold uppercase text-[16px]"}>
                                R$ {zipData.value}
                            </p>
                        </div>
                    </div>
                )}
                {unavailableAddress}
                {additionalErrors && !errors.isUnavailable && (
                    <p className={`text-sm mt-3 leading-none uppercase font-bold ${highContrast ? "highTitleThird" : "text-sabin-red-default"}`}>
                        INSIRA SEU CEP PARA DAR CONTINUIDADE
                    </p>
                )}
            </div>
            {addToCartButton}
            <SchedulingTerm />
        </Fragment>
    )
}

export default HomeDeliveryPicker;
